import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Std$Bolt0 from "bolt0/./std.bs.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Term_bs$SolvuuLang0 from "./term_bs.bs.js";
import * as Term_atd$SolvuuLang0 from "./term_atd.bs.js";

function of_string(x) {
  switch (x) {
    case "json":
      return (
        /* Json */
        826371656
      );

    case "solvuu":
      return (
        /* Solvuu */
        -522825178
      );

    default:
      return Curry._2(Std$Bolt0.failwithf(
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["Invalid solvuu syntax: ",
      /* String */
      Block.__(2, [
      /* No_padding */
      0,
      /* End_of_format */
      0])]), "Invalid solvuu syntax: %s"]), x,
      /* () */
      0);
  }
}

function to_string(param) {
  if (param >= 826371656) {
    return "json";
  } else {
    return "solvuu";
  }
}

var Fmt = {
  of_string: of_string,
  to_string: to_string
};

function of_term(term) {
  var _param =
  /* tuple */
  [
  /* [] */
  0, term];

  while (true) {
    var param = _param;
    var term$1 = param[1];
    var l = param[0];

    if (typeof term$1 === "number" || term$1[0] !== 3257473) {
      return (
        /* tuple */
        [Bolt0_list$Bolt0.rev(l), term$1]
      );
    } else {
      var match = term$1[1];
      var match$1 = match[0];

      if (typeof match$1 === "number" || match$1[0] !== 89433895) {
        return (
          /* tuple */
          [Bolt0_list$Bolt0.rev(l), term$1]
        );
      } else {
        var match$2 = match$1[1];
        _param =
        /* tuple */
        [
        /* :: */
        [
        /* tuple */
        [match$2[0], match[1]], l], match$2[1]];
        continue;
      }
    }
  }

  ;
}

function to_term(param) {
  return Bolt0_list$Bolt0.fold_left(function (term, param) {
    return (
      /* `App */
      [3257473,
      /* tuple */
      [
      /* `Lambda */
      [89433895,
      /* tuple */
      [param[0], term]], param[1]]]
    );
  }, param[1], Bolt0_list$Bolt0.rev(param[0]));
}

var Let = {
  of_term: of_term,
  to_term: to_term
};
var Json = Term_bs$SolvuuLang0;
var json_of_project = Term_atd$SolvuuLang0.json_of_project;
var json_of_scalar = Term_atd$SolvuuLang0.json_of_scalar;
var json_of_blob_id = Term_atd$SolvuuLang0.json_of_blob_id;
var json_of_uri = Term_atd$SolvuuLang0.json_of_uri;
var json_of_extern = Term_atd$SolvuuLang0.json_of_extern;
var json_of_var = Term_atd$SolvuuLang0.json_of_var;
var json_of_intrinsic = Term_atd$SolvuuLang0.json_of_intrinsic;
var json_of_app = Term_atd$SolvuuLang0.json_of_app;
var json_of_arrow = Term_atd$SolvuuLang0.json_of_arrow;
var json_of_nullable_ = Term_atd$SolvuuLang0.json_of_nullable_;
var json_of_list_ = Term_atd$SolvuuLang0.json_of_list_;
var json_of_record = Term_atd$SolvuuLang0.json_of_record;
var json_of_container = Term_atd$SolvuuLang0.json_of_container;
var json_of_ascription = Term_atd$SolvuuLang0.json_of_ascription;
var json_of_conditional = Term_atd$SolvuuLang0.json_of_conditional;
var json_of_error = Term_atd$SolvuuLang0.json_of_error;
var json_of_future = Term_atd$SolvuuLang0.json_of_future;
var json_of_meta = Term_atd$SolvuuLang0.json_of_meta;
var json_of_closure = Term_atd$SolvuuLang0.json_of_closure;
var json_of_dir = Term_atd$SolvuuLang0.json_of_dir;
var json_of_t = Term_atd$SolvuuLang0.json_of_t;
var project_of_json = Term_atd$SolvuuLang0.project_of_json;
var scalar_of_json = Term_atd$SolvuuLang0.scalar_of_json;
var blob_id_of_json = Term_atd$SolvuuLang0.blob_id_of_json;
var uri_of_json = Term_atd$SolvuuLang0.uri_of_json;
var extern_of_json = Term_atd$SolvuuLang0.extern_of_json;
var var_of_json = Term_atd$SolvuuLang0.var_of_json;
var intrinsic_of_json = Term_atd$SolvuuLang0.intrinsic_of_json;
var app_of_json = Term_atd$SolvuuLang0.app_of_json;
var arrow_of_json = Term_atd$SolvuuLang0.arrow_of_json;
var nullable__of_json = Term_atd$SolvuuLang0.nullable__of_json;
var list__of_json = Term_atd$SolvuuLang0.list__of_json;
var record_of_json = Term_atd$SolvuuLang0.record_of_json;
var container_of_json = Term_atd$SolvuuLang0.container_of_json;
var ascription_of_json = Term_atd$SolvuuLang0.ascription_of_json;
var conditional_of_json = Term_atd$SolvuuLang0.conditional_of_json;
var error_of_json = Term_atd$SolvuuLang0.error_of_json;
var future_of_json = Term_atd$SolvuuLang0.future_of_json;
var meta_of_json = Term_atd$SolvuuLang0.meta_of_json;
var closure_of_json = Term_atd$SolvuuLang0.closure_of_json;
var dir_of_json = Term_atd$SolvuuLang0.dir_of_json;
var t_of_json = Term_atd$SolvuuLang0.t_of_json;
export { Json, json_of_project, json_of_scalar, json_of_blob_id, json_of_uri, json_of_extern, json_of_var, json_of_intrinsic, json_of_app, json_of_arrow, json_of_nullable_, json_of_list_, json_of_record, json_of_container, json_of_ascription, json_of_conditional, json_of_error, json_of_future, json_of_meta, json_of_closure, json_of_dir, json_of_t, project_of_json, scalar_of_json, blob_id_of_json, uri_of_json, extern_of_json, var_of_json, intrinsic_of_json, app_of_json, arrow_of_json, nullable__of_json, list__of_json, record_of_json, container_of_json, ascription_of_json, conditional_of_json, error_of_json, future_of_json, meta_of_json, closure_of_json, dir_of_json, t_of_json, Fmt, Let };
/* No side effect */